import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/_authed/_sidebar/agriculture')({
    component: AgricultureLayout,
})

function AgricultureLayout() {
    return <Outlet />
}
